import { createAction, props } from '@ngrx/store';

import { ClientCreate } from '@lockton-apps/shared/interfaces';

import { ClientSubClientNewActionTypes } from './types';

export const clientAdded = createAction(
  ClientSubClientNewActionTypes.ClientAdded,
  props<{ client: ClientCreate }>()
);
